const USER_ID = "vvGfqZKmMvfsC9za4";
// const SERVICE_ID = "service_49nequ7"; // gmail
const SERVICE_ID = "service_zbv4o23"; // zoho
const TEMPLATE_ID = "template_jm06kta";

export { USER_ID, SERVICE_ID, TEMPLATE_ID };